import React, { useState, useEffect, useRef } from "react";
import { cn } from "../../../Utils/helper";
import images from "../../../images";
import { CheckboxCommon } from "../CheckBox/CheckboxCommon";
import { useTranslation } from "react-i18next";

export function FormSelectSegmentation({
  options = [],
  value = [],
  onChange,
  className,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const selectRef = useRef(null);
  const maxSelections = 3;

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerHeight <= 480);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleCheckboxChange = (optionValue) => {
    const nonAgeGenderFilters = value.filter(
      (v) => v !== "age" && v !== "gender"
    );

    let newValue;
    if (value.includes(optionValue)) {
      newValue = value.filter((v) => v !== optionValue);
    } else {
      if (
        optionValue !== "age" &&
        optionValue !== "gender" &&
        nonAgeGenderFilters.length >= maxSelections
      ) {
        return;
      }
      newValue = [...value, optionValue];
    }

    onChange({ target: { value: newValue } });
  };

  const nonAgeGenderCount = value.filter(
    (v) => v !== "age" && v !== "gender"
  ).length;

  return (
    <div className="relative" ref={selectRef}>
      {/* Trigger Button */}
      <div className="flex flex-row gap-2">
        <div
          className={cn(
            "flex gap-1.5 items-center px-2.5 py-2.5 w-full leading-none whitespace-nowrap bg-stone-100 rounded-xl border border-solid border-stone-200 min-h-[42px] cursor-pointer",
            className
          )}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="flex-1 shrink self-stretch my-auto text-sm text-gray-600">
            {t("common.formSelectSegmentation.selectFilter")}
          </span>
          <img
            loading="lazy"
            src={images.FilterIcon}
            alt=""
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
          />
        </div>
        {/* <div className="rounded-full p-1 max-w-[56px] h-[56px] w-full flex justify-center items-center bg-gradient-to-r from-green-400 to-blue-500">
          <img src={images.GenAIIconWhite} alt="" className="w-[20px]" />
        </div> */}
      </div>

      {/* Dropdown */}
      {/* {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-transparent z-0"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10 ">
            <span className="px-4 py-2 text-sm text-gray-500">
              {t("common.formSelectSegmentation.requiredSelectAgeGender")}
            </span>

            {options.map((option, index) => (
              <label
                key={index}
                className="flex items-center space-x-2 gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
              >
                <CheckboxCommon
                  key={option.value}
                  checked={value.includes(option.value)}
                  onCheckedChange={() => handleCheckboxChange(option.value)}
                  className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
                />
                <span className="text-sm font-medium text-gray-700">
                  {option.label}
                </span>
              </label>
            ))}
            {nonAgeGenderCount >= maxSelections && (
              <div className="px-4 py-2 text-sm text-gray-500">
                {t("common.formSelectSegmentation.maxFilterReached")}
              </div>
            )}
          </div>
        </>
      )} */}
      {/* Dropdown hoặc Modal tùy thuộc vào thiết bị */}
      {isOpen && (
        <>
          {isMobile ? (
            // Hiển thị dưới dạng modal trên thiết bị di động
            <div className="fixed inset-0 bg-white z-50 flex flex-col">
              <div className="flex justify-between items-center p-4 border-b border-gray-200">
                <span className="text-sm font-medium text-gray-600">
                  {t("common.formSelectSegmentation.selectFilter")}
                </span>
                <button onClick={() => setIsOpen(false)}>
                  <span className="text-sm text-gray-600">Done</span>
                </button>
              </div>
              <div className="flex-1 overflow-auto p-4">
                <span className="px-4 py-2 text-sm text-gray-500">
                  {t("common.formSelectSegmentation.requiredSelectAgeGender")}
                </span>
                {options.map((option, index) => (
                  <label
                    key={index}
                    className="flex items-center space-x-2 gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  >
                    <CheckboxCommon
                      key={option.value}
                      checked={value.includes(option.value)}
                      onCheckedChange={() => handleCheckboxChange(option.value)}
                      className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
                    />
                    <span className="text-sm font-medium text-gray-700">
                      {option.label}
                    </span>
                  </label>
                ))}
                {nonAgeGenderCount >= maxSelections && (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    {t("common.formSelectSegmentation.maxFilterReached")}
                  </div>
                )}
              </div>
            </div>
          ) : (
            // Hiển thị dropdown trên thiết bị lớn hơn
            <>
              <div
                className="fixed inset-0 bg-transparent z-0"
                onClick={() => setIsOpen(false)}
              />
              <div className="absolute top-full left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg z-10 max-h-[250px] overflow-auto">
                <span className="px-4 py-2 text-sm text-gray-500">
                  {t("common.formSelectSegmentation.requiredSelectAgeGender")}
                </span>
                {options.map((option, index) => (
                  <label
                    key={index}
                    className="flex items-center space-x-2 gap-2 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  >
                    <CheckboxCommon
                      key={option.value}
                      checked={value.includes(option.value)}
                      onCheckedChange={() => handleCheckboxChange(option.value)}
                      className="rounded-none w-4 h-4 bg-white border border-solid border-black data-[state=checked]:bg-white data-[state=checked]:text-black"
                    />
                    <span className="text-sm font-medium text-gray-700">
                      {option.label}
                    </span>
                  </label>
                ))}
                {nonAgeGenderCount >= maxSelections && (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    {t("common.formSelectSegmentation.maxFilterReached")}
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
